export default {
  token: (state) => state.token,
  profile: (state) => state.profile,
  searchTerm: (state) => state.searchTerm,
  components: (state) => state.components,
  vin: (state) => state.vin,
  vehicle: (state) => state.vehicle
}



// WEBPACK FOOTER //
// ./src/store/modules/alldata/getters.js